<template>
	<el-drawer size="40%" title="人员管理" :visible.sync="drawer" :modal-append-to-body="false" :wrapperClosable="false" class="customer-drawer-common">
		<el-transfer v-model="value" :data="lists" 
		      :titles="['可选人员','技能组内']"
			  filterable
			 :filter-method="filterMethod"
			  filter-placeholder="请输入用户名"
		     :props="{
			      key: 'userId',
			      label: 'nickname'
			  }" v-loading="loading"></el-transfer>
		  <div class="footer">
		  		<el-button @click="drawer = false"  size="mini">取 消</el-button>
		  		<el-button type="primary" size="mini" @click="onSave" :loading="loadingBtn">{{ loadingBtn ? '提交中 ...' : '确 定' }}
		  		</el-button>
		   </div>
	</el-drawer>
</template>

<script>
	export default {
		data() {
			return {
				drawer: false,
				value:[],
				lists:[],
				loadingBtn:false,
				skillGroup:'',
				brand:'',
				loading:false
			}
		},
		methods: {
			filterMethod(query, item) {
				return item.nickname.indexOf(query) > -1;
			},
			async getAllUser(row){
				await this.$api.getSystemSkillGroupAllUsers({
					// user:{
						brandList:[this.brand],
					// }
				}).then(res => {
					this.lists = res.data;
				})
			},
			async getUser(){
				await this.$api.getSystmeSkillGroupUsers({skillGroup:this.skillGroup}).then(res => {
					this.value = [];
					this.$nextTick(()=>{
						for(let item of res.data){
						   this.value.push(item.id)
					    }
						this.loading = false;
					})
				})
			},
			onSave(){
				this.$api.setSystemSkillGroupToBind({
					agentIdList: this.value,
					brand: this.brand,
					skillGroup:this.skillGroup
				}).then(res => {
					if(res.errcode == 0) {
						this.$notify.success('操作成功');
						this.drawer = false;
					}
				})
			},
			async onOpen(row){
				this.drawer = true;
				this.loading = true;
				this.skillGroup = row.skillId;
				this.brand = row.childBrand;
				await this.getAllUser();
				await this.getUser()
			}
		}
	}
</script>

<style>
</style>
